import React from 'react';
import { Section } from './ui';

// Solo lectura: se calcula con backend/scripts/pricing y se guarda con /admin. Nunca llega a la tienda.
const usd = (n) => (n == null ? '—' : `US$ ${parseFloat(n).toFixed(2)}`);
const pen = (n) => (n == null ? '—' : `S/ ${parseFloat(n).toLocaleString('es-PE', { maximumFractionDigits: 0 })}`);

export default function CostSection({ product: p }) {
  const rows = [
    ['Costo de origen', usd(p.cost_usd)],
    ['Peso del paquete', p.weight_kg ? `${parseFloat(p.weight_kg).toFixed(2)} kg · ${p.weight_source || '—'}` : '—'],
    ['Flete', usd(p.freight_usd)],
    ['Impuesto (esperado)', usd(p.tax_usd)],
    ['Taxi al almacén', usd(p.other_cost_usd)],
    ['Costo total en Lima', pen(p.landed_cost_pen)],
    ['Margen actual (sin IGV)', p.margin_pct != null ? `${p.margin_pct}%` : '—'],
  ];
  return (
    <Section title="Costos (solo admin)" hint="No se muestran al público ni salen por la API">
      <dl className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-2 text-sm">
        {rows.map(([k, v]) => (
          <div key={k} className="flex items-baseline justify-between gap-3 border-b border-white/10 pb-1">
            <dt className="text-brand-faint">{k}</dt>
            <dd className="font-medium">{v}</dd>
          </div>
        ))}
      </dl>
    </Section>
  );
}
